import React from 'react';
import { Link } from 'react-router-dom';
import './CompetitionCard.css';

/**
 * CompetitionCard component
 * Displays a single competition in card format
 * T064: Competition card for list display
 */
const CompetitionCard = ({ competition }) => {
  const {
    competitionId,
    name,
    competitionType,
    status,
    startDate,
    endDate,
    divisions = [],
  } = competition;

  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric' 
    });
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'active':
        return 'status-active';
      case 'upcoming':
        return 'status-upcoming';
      case 'completed':
        return 'status-completed';
      default:
        return '';
    }
  };

  const getTypeLabel = (type) => {
    switch (type) {
      case 'league':
        return 'League';
      case 'knockout':
        return 'Knockout';
      case 'bespoke':
        return 'Bespoke';
      default:
        return type;
    }
  };

  return (
    <Link to={`/competitions/${competitionId}`} className="competition-card">
      <div className="competition-card-header">
        <h3 className="competition-name">{name}</h3>
        <span className={`competition-status ${getStatusClass(status)}`}>
          {status}
        </span>
      </div>

      <div className="competition-details">
        <div className="competition-type">
          <span className="label">Type:</span>
          <span className="value">{getTypeLabel(competitionType)}</span>
        </div>

        <div className="competition-dates">
          <span className="label">Dates:</span>
          <span className="value">
            {formatDate(startDate)} - {formatDate(endDate)}
          </span>
        </div>

        {divisions.length > 0 && (
          <div className="competition-divisions">
            <span className="label">Divisions:</span>
            <span className="value">{divisions.length}</span>
          </div>
        )}
      </div>

      <div className="competition-card-footer">
        <span className="view-link">View Details →</span>
      </div>
    </Link>
  );
};

export default CompetitionCard;
